module.exports = __webpack_public_path__ + "static/media/ASP2.9fdaa0a7.jpg";